const imgPath = process.env.IMG_PATH;
export const profileUrl = url => {
    if (!url) return imgPath + 'images/img-profile.png';

    return url;
};

export const noImage = () => {
    return 'javascript:this.src="' + imgPath + 'images/img-no-video-thumb@2x.png"';
};

export const setImgPath = url => {
    return imgPath + url;
};
